import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { Zona } from 'src/app/Models/zona/zona';
import { DataService } from 'src/app/Service/data.service';
import { ALertOption } from 'src/app/Models/alert/alert-option';

@Component({
  selector: 'app-add-zona',
  templateUrl: './add-zona.component.html',
  styleUrls: ['./add-zona.component.css']
})
export class AddZonaComponent implements OnInit {
  @ViewChild('frmnewzona', null) frmnewzona: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('loading', null) loading: LoadingComponent;
  public funcion: Function;
  public isShow: boolean = false;
  public isedit: boolean = false;
  public usuario: any;
  public zona: Zona;
  public options: ALertOption = new ALertOption();
  constructor(private data: DataService) { }

  ngOnInit() {
  }


  public show(affterfunction: Function = null) {

    this.funcion = affterfunction;
    this.isShow = true;
    //this.zona = new Zona();
    setTimeout(async () => {
      this.frmnewzona.nativeElement.click();
      this.loading.hide();
    }, 10);
  }


  close() {
    this.btnclose.nativeElement.click();
    setTimeout(() => { this.isShow = false; }, 500);
    setTimeout(() => { if (this.funcion != null) { this.funcion(); } }, 10);
  }

  GuardarZona(){
    this.data.Post(this.data.api.zona, this.zona).subscribe(
      (res)=>{
        this.data.notify("Datos Guardados exitosamente","Exito",this.data.alertType.success,this.options,() =>{this.close()})
      },
      (err)=>{console.log(err);
      }
    );
  }

  EditZona(){
    this.data.Put(this.data.api.zona,this.zona.idzona, this.zona).subscribe(
      (res)=>{
        this.data.notify("Datos Actualizados exitosamente","Exito",this.data.alertType.success,this.options,() =>{this.close()})
      },
      (err)=>{console.log(err);
      }
    );
  }

  EliminarZona(idzona){
    return this.data.Delete(this.data.api.zona,idzona)
  }

  Save(){
    if(this.zona.idzona && this.isedit){
      this.EditZona();
    }else{
      this.GuardarZona();
    }
  }

}
